import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";
import useSignIn from "./useSignin";
import SignInForm from "./SigninForm";
import { SignInFormSchema } from "./ValidationSchema";

interface SignInData {
  access_token: any;
  role: any;
  permissions: any;
}

// interface SignInMutation {
//   isSuccess: boolean;
//   isError: boolean;
//   isPending: boolean;
//   data?: SignInData;
//   response: any;
//   error?: {
//     response?: {
//       status: number;
//     };
//     data?: {
//       detail: string;
//     };
//   };
//   mutate: (data: any) => void;
//   access_token:any
// }

interface ErrorResponse {
  response?: {
    status: number;
    data: {
      detail: string;
    };
  };
}

function SignIn() {
  const navigate = useNavigate();
  const { signInMutation, visible, handleShowPassword } = useSignIn();
  const { login, hasAuthenticated, userDetails } = useAuth();
  // const responseData = signInMutation?.data as
  //   | AxiosResponse<SignInData>
  //   | undefined;
  const responseData = signInMutation?.data as SignInData | undefined; // Directly treat it as SignInData

  const role = userDetails?.role;

  useEffect(() => {
    if (signInMutation.isSuccess && responseData) {
      const accessToken = responseData?.access_token;
      login({
        access_token: accessToken,
      });
      window.location.href = "/dashboard";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseData, signInMutation.isSuccess]);

  useEffect(() => {
    if (hasAuthenticated && role?.includes("Admin")) {
      navigate("/dashboard");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAuthenticated, role]);

  const onSubmit = (formData: { email: string; password: string }) => {
    signInMutation.mutate(formData);
  };

  useEffect(() => {
    if (
      signInMutation.isError &&
      (signInMutation.error as ErrorResponse)?.response?.status !== 401
    ) {
      // Handle error (e.g., display error message)
    }
  }, [signInMutation.isError, signInMutation?.error]);

  return (
    <div className="login mx-auto bg-primarybg shadow-xl flex h-[100svh] md:h-screen overflow-y-hidden">
      <SignInForm
        onSubmit={onSubmit}
        isError={signInMutation.isError}
        isPending={signInMutation.isPending}
        message={
          (signInMutation.error as ErrorResponse)?.response?.data?.detail ||
          "Unknown error occurred"
        }
        visible={visible}
        handleShowPassword={handleShowPassword}
        SignInFormSchema={SignInFormSchema}
        label="Sign In"
      />
    </div>
  );
}

export default SignIn;
